<template>
  <transition name="fade">
    <div v-if="isGateOpen" class="gate-wrapper">
      <div class="gate-container">
        <form ref="form" class="gate">
          <router-link
            :to="{ name: 'home' }"
            class="gate-logo"
            @click.native="$store.commit('setCurrentSlide', 0)"
          >
            <img src="/images/logo.svg" alt="" />
          </router-link>
          <div class="title">Wpisz datę <br class="only-mobile" />urodzin</div>
          <div class="inputs-wrapper">
            <div class="inputs-container">
              <!-- Day -->
              <div class="input-wrapper">
                <label class="input-wrapper__label" for="day">Dzień</label>
                <input
                  ref="day"
                  placeholder="DD"
                  class="input-wrapper__input"
                  type="number"
                  name="day"
                  data-max-chars="2"
                />
              </div>
              <!-- Month -->
              <div class="input-wrapper input-wrapper--month">
                <label class="input-wrapper__label" for="day">Miesiąc</label>
                <input
                  ref="month"
                  placeholder="MM"
                  class="input-wrapper__input"
                  type="number"
                  name="month"
                  data-max-chars="2"
                />
              </div>
              <!-- Year -->
              <div class="input-wrapper input-wrapper--year">
                <label class="input-wrapper__label" for="day">Rok</label>
                <input
                  ref="year"
                  placeholder="RRRR"
                  class="input-wrapper__input"
                  type="number"
                  name="year"
                  data-max-chars="4"
                />
              </div>
            </div>
            <!-- Errors -->
            <transition name="fade">
              <div ref="error" class="error hidden" />
            </transition>
          </div>
          <div>
            <button ref="submit" class="btn-gate" type="submit">
              Wejdź na stronę
            </button>
          </div>
        </form>

        <p class="cookie-info">
          Przechodząc dalej akceptujesz&nbsp;
          <a
            class="underline"
            target="_blank"
            href="https://grupazywiec.pl/polityka-cookies/"
            rel="noopener noreferrer"
          >
            politykę plików cookies.</a
          >
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
const setCookies = (key, value) => {
  const DOMAIN = window.location.hostname
    .split('.')
    .splice(-2)
    .join('.')
  const expireDate = new Date().setDate(new Date().getDate() + 365)
  document.cookie = `${key}=${JSON.stringify(
    value
  )}; domain=${DOMAIN}; expires=${expireDate}; path=/`
}
const getCookies = key => {
  const name = `${key}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export default {
  computed: {
    isGateOpen() {
      return this.$store.state.isGateOpen
    }
  },
  async mounted() {
    await this.$nextTick()

    const error = message => {
      const { error, form } = this.$refs
      error.innerText = message

      if (message) {
        form.classList.add('gate-form--invalid')
        error.classList.remove('hidden')
      } else {
        form.classList.remove('gate-form--invalid')
        error.classList.add('hidden')
      }

      return message
    }

    const getFormData = () => {
      const { day, month, year } = this.$refs
      return {
        day: day.value,
        month: month.value,
        year: year.value
      }
    }

    const toggleInputs = evt => {
      const { month, year, submit } = this.$refs
      const input = evt.target
      const maxChars = Number(input.getAttribute('data-max-chars') || Infinity)

      input.value = input.value.slice(0, maxChars)

      if (input === year && input.value.length >= maxChars) {
        submit.focus()
        return
      }

      if (input.value.length >= maxChars) {
        switch (input.name) {
          case 'day':
            month.focus()
            break
          case 'month':
            year.focus()
            break
        }
      }
    }

    const validateDate = ({ day, month, year }) => {
      const isValidDate = date =>
        /^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)\d\d$/.test(date)

      const formattedDate = `${month.padStart(2, '0')}${day.padStart(
        2,
        '0'
      )}${year}`
      const userDate = new Date(year, month - 1, day).getTime()
      const minDate = new Date().setFullYear(new Date().getFullYear() - 18)

      if (!isValidDate(formattedDate) || year < 1910) {
        error('Wpisz poprawną datę urodzenia')
        return false
      } else if (userDate > minDate) {
        error('Strona dostępna jest tylko dla użytkowników pełnoletnich')
        return false
      }

      return true
    }

    const submit = () => {
      const { day, month, year } = this.$refs
      const formData = getFormData()

      if (validateDate(formData)) {
        this.$gtag && this.$gtag.event('gate_pass')
        this.$store.commit('toggleGate')
        setCookies('valid-age', true)

        day.removeEventListener('input', toggleInputs)
        month.removeEventListener('input', toggleInputs)
        year.removeEventListener('input', toggleInputs)
      }
    }

    if (!getCookies('valid-age')) {
      this.$gtag && this.$gtag.event('gate')
      if (!this.isGateOpen) this.$store.commit('toggleGate')

      const { day, month, year, form } = this.$refs

      if (day && month && year && form) {
        day.addEventListener('input', toggleInputs)
        month.addEventListener('input', toggleInputs)
        year.addEventListener('input', toggleInputs)

        form.addEventListener('submit', evt => {
          evt.preventDefault()
          evt.target.blur()
          submit()
        })
      }
    } else {
      setTimeout(() => {
        if (this.isGateOpen) this.$store.commit('toggleGate')
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
$gate-background-color: #b81821;
$gate-z-index: z(gate);
$text-color: #fff;

.gate-wrapper {
  @include fill-space;
  bottom: 0;
  min-height: $vh;
  z-index: $gate-z-index;
  background: $gate-background-color;
  color: $text-color;
  overflow: scroll;
  overflow-x: hidden;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: 1px;
  line-height: 1.6;
  font-style: normal;
  font-weight: 400;

  @include media-up(lg) {
    overflow: auto;
  }
}
.gate-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
  height: 100%;
}
.gate {
  @include center-content;
  flex-direction: column;
  width: 100%;
  @include media-up(lg) {
    margin: auto 0;
  }
}
.gate-logo {
  margin-top: 31px;
  width: 84px;
  height: auto;
  @include media-up(md) {
    margin-top: 100px;
    width: 165px;
  }
  @include media-up(lg) {
    margin-top: 0;
    width: 100px;
  }
  @include media-up(xxl) {
    width: 162px;
  }
}
.title {
  text-align: center;
  font-size: 36px;
  line-height: 1.22;
  font-family: $bold-font;
  text-transform: uppercase;
  margin-top: 45px;
  max-width: 230px;
  @include media-up(md) {
    margin-top: 110px;
    font-size: 42px;
    max-width: none;
  }
  @include media-up(lg) {
    margin-top: 47px;
    font-size: 46px;
  }
}
.inputs-wrapper {
  @include center-content;
  flex-direction: column;
  margin-top: 32px;
  @media (min-width: 1280px) {
    margin-top: 40px;
  }
}
.inputs-container {
  @include media-up(md) {
    @include center-content;
  }
}
.input-wrapper {
  display: flex;
  flex-direction: column;
  &--month {
    margin-top: 26px;
    @include media-up(md) {
      margin-top: 0;
      margin-left: 19px;
    }
  }
  &--year {
    margin-top: 26px;
    @include media-up(md) {
      margin-top: 0;
      margin-left: 19px;
    }
  }
  &__input {
    @include reset-input(number);

    color: $text-color;
    border: 1px solid #fff;
    background: transparent;
    height: 36px;
    width: 120px;
    padding: 12.5px 25px;
    font-size: 16px;
    @include media-up(md) {
      padding: 13px 10px;
    }
    &::placeholder {
      color: $text-color;
    }
  }
  &__label {
    padding-left: 15px;
    text-transform: uppercase;
    font-size: 12px;
    margin-bottom: 9px;
    font-family: $regular-font;
    @include media-up(md) {
      padding-left: 10px;
    }
  }
}
.btn-gate {
  @include reset-button;
  @include center-content;

  background: #fff;
  text-transform: uppercase;
  font-family: $regular-font;
  color: $gate-background-color;
  height: 37px;
  width: 200px;
  outline: none;
  font-size: 12px;
  transition: background 0.3s, text-shadow 0.3s;
  margin-top: 32px;
  &:hover {
    text-shadow: 0px 0px 1px;
    background: darken($color: #fff, $amount: 5%);
  }
}
.cookie-info {
  font-size: 10px;
  color: $text-color;
  text-transform: uppercase;
  line-height: 1.5;
  letter-spacing: 0.5px;
  padding: 62px 31px 35px;
  @include media-up(md) {
    display: flex;
    align-items: flex-start;
  }
  &__first {
    font-family: $bold-font;
    @include media-up(md) {
      margin-right: 54px;
    }
    @include media-up(xxl) {
      margin-right: 127px;
    }
  }
  &__second {
    font-family: $regular-font;
    @include media-down(md) {
      margin-top: 17px;
    }
  }
}
.error {
  margin-top: 20px;
  font-family: $light-font;
  font-size: 12px;
  @include media-up(md) {
    width: 100%;
    text-align: center;
  }
  @include media-up(xxl) {
    font-size: 18px;
  }
}
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.only-mobile {
  @include hide-up(md);
}
.not-mobile {
  @include hide-down(md);
}

.cookie-info .underline {
  margin-left: 2px;
}
</style>
